// frontend/src/components/admin/modules/Treasury.js
import { api } from '../../../services/api.js';
import { Notification } from '../../../components/Notification.js';

// Inyección dinámica de ApexCharts (Librería nativa de Tabler)
const loadApexCharts = async () => {
    if (window.ApexCharts) return;
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/apexcharts';
        script.onload = resolve;
        document.head.appendChild(script);
    });
};

const tablerStyles = `
    <style>
        .tabler-card { background: #1e293b; border: 1px solid #334155; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); margin-bottom: 1.5rem; overflow: hidden; }
        .tabler-header { padding: 1.25rem 1.5rem; border-bottom: 1px solid #334155; display: flex; align-items: center; justify-content: space-between; background: transparent; flex-wrap: wrap; gap: 10px; }
        .tabler-title { margin: 0; font-size: 1.25rem; font-weight: 600; color: #f8fafc; display: flex; align-items: center; gap: 0.5rem; }
        .tabler-body { padding: 1.5rem; }
        .tabler-table-container { overflow-x: auto; width: 100%; }
        .tabler-table { width: 100%; border-collapse: collapse; white-space: nowrap; }
        .tabler-table th { padding: 0.75rem 1rem; text-align: left; font-size: 0.75rem; font-weight: 600; color: #94a3b8; text-transform: uppercase; border-bottom: 1px solid #334155; letter-spacing: 0.05em; background: #0f172a; }
        .tabler-table td { padding: 0.875rem 1rem; font-size: 0.875rem; color: #cbd5e1; border-bottom: 1px solid #334155; vertical-align: middle; }
        .tabler-table tbody tr:hover { background: rgba(255,255,255,0.02); }
        .tabler-table tfoot td { font-weight: 700; color: #f8fafc; border-top: 2px solid #475569; background: #0f172a; font-size: 0.95rem; }
        
        .tabler-badge { padding: 0.25rem 0.6rem; border-radius: 4px; font-size: 0.75rem; font-weight: 600; display: inline-flex; align-items: center; gap: 0.25rem; border: 1px solid transparent; }
        .badge-green { background: rgba(16, 185, 129, 0.1); color: #34d399; border-color: rgba(16, 185, 129, 0.2); }
        .badge-red { background: rgba(239, 68, 68, 0.1); color: #f87171; border-color: rgba(239, 68, 68, 0.2); }
        .badge-yellow { background: rgba(245, 158, 11, 0.1); color: #fbbf24; border-color: rgba(245, 158, 11, 0.2); }
        .badge-blue { background: rgba(59, 130, 246, 0.1); color: #60a5fa; border-color: rgba(59, 130, 246, 0.2); }
        
        .font-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }
        .text-right { text-align: right !important; }
        .text-center { text-align: center !important; }
        .text-muted { color: #64748b; font-size: 0.8rem; }
        
        .tabler-btn { display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; padding: 0.5rem 1rem; font-size: 0.875rem; font-weight: 500; border-radius: 6px; cursor: pointer; transition: all 0.2s; border: 1px solid transparent; }
        .btn-primary { background: #3b82f6; color: white; border-color: #3b82f6; }
        .btn-primary:hover:not(:disabled) { background: #2563eb; }
        .btn-success { background: #10b981; color: white; border-color: #10b981; }
        .btn-outline { background: transparent; border-color: #475569; color: #cbd5e1; }
        .btn-outline:hover:not(:disabled) { background: #334155; color: white; }
        
        .tabler-input, .tabler-select { width: 100%; padding: 0.5rem 0.75rem; background: #0f172a; border: 1px solid #475569; border-radius: 6px; color: #f8fafc; font-size: 0.875rem; outline: none; transition: border-color 0.2s; }
        .tabler-input:focus, .tabler-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2); }
        
        .filter-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1rem; align-items: end; background: #0f172a; padding: 1.25rem; border-radius: 8px; border: 1px solid #334155; margin-bottom: 1.5rem; }
        .filter-group label { display: block; font-size: 0.75rem; font-weight: 600; color: #94a3b8; margin-bottom: 0.5rem; text-transform: uppercase; }
        
        /* Dashboard Widgets */
        .widget-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 1rem; margin-bottom: 1.5rem; }
        .widget-card { background: #1e293b; border: 1px solid #334155; border-radius: 8px; padding: 1.25rem; display: flex; flex-direction: column; position: relative; overflow: hidden; }
        .widget-card::before { content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 4px; background: #3b82f6; border-radius: 8px 0 0 8px; }
        .widget-card.green::before { background: #10b981; }
        .widget-card.red::before { background: #ef4444; }
        .widget-card.purple::before { background: #8b5cf6; }
        .widget-title { color: #94a3b8; font-size: 0.75rem; font-weight: 700; text-transform: uppercase; margin-bottom: 0.5rem; letter-spacing: 0.05em; }
        .widget-value { color: #f8fafc; font-size: 1.75rem; font-weight: 700; line-height: 1.2; font-family: ui-monospace, monospace; }
        .apexcharts-tooltip { background: #0f172a !important; border: 1px solid #334155 !important; box-shadow: 0 4px 6px rgba(0,0,0,0.3) !important; color: white !important; }
        .apexcharts-tooltip-title { background: #1e293b !important; border-bottom: 1px solid #334155 !important; }
    </style>
`;

// =================================================================================
// ⚙️ 0. GESTIÓN DE COMISIONES POR USUARIO/ROL
// =================================================================================
export async function renderCommissionsManagement(container, notificationContainer) {
    container.innerHTML = `
        ${tablerStyles}
        <div class="tabler-card">
            <div class="tabler-header">
                <h3 class="tabler-title"><i class="fas fa-percent text-muted"></i> Estructura de Comisiones (Módulo B2B)</h3>
                <button id="refreshCommissions" class="tabler-btn btn-outline"><i class="fas fa-sync-alt"></i> Recargar</button>
            </div>
            <div class="tabler-body">
                <p class="text-muted" style="margin-bottom: 1.5rem;">Asigna el esquema de cobro para cada usuario del sistema. Esta configuración aplica tanto a los reportes de Taquillas físicas como a los operadores digitales (App Win/Place).</p>
                <div class="tabler-table-container">
                    <table class="tabler-table">
                        <thead>
                            <tr>
                                <th>Usuario / Red</th>
                                <th>Rol del Sistema</th>
                                <th>Tipo de Comisión</th>
                                <th>Valor a Cobrar</th>
                                <th class="text-center">Acción</th>
                            </tr>
                        </thead>
                        <tbody id="commissionsBody">
                            <tr><td colspan="5" class="text-center text-muted py-5"><i class="fas fa-spinner fa-spin"></i> Obteniendo estructuras...</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `;

    const tbody = container.querySelector('#commissionsBody');

    const loadCommissions = async () => {
        try {
            const [users, configData] = await Promise.all([
                api.get('/users'),
                api.get('/configs/cashier')
            ]);

            const configsArr = Array.isArray(configData) ? configData : [configData];
            
            const activeUsers = users.filter(u => u.role === 'cashier' || u.role === 'payout_agent' || u.role === 'admin');

            tbody.innerHTML = activeUsers.map(u => {
                const conf = configsArr.find(c => c.user_id === u.id) || {};
                const cType = conf.commission_type || 'PERCENT';
                const cVal = parseFloat(conf.commission_value || 0).toFixed(2);

                let roleBadge = '';
                if(u.role === 'payout_agent') roleBadge = '<span class="tabler-badge badge-blue"><i class="fas fa-mobile-alt"></i> App Operador</span>';
                else if(u.role === 'cashier') roleBadge = '<span class="tabler-badge badge-yellow"><i class="fas fa-desktop"></i> Taquilla Física</span>';
                else roleBadge = '<span class="tabler-badge badge-gray"><i class="fas fa-user-shield"></i> Supervisor</span>';

                return `
                <tr>
                    <td>
                        <div style="font-weight:600; color:#f8fafc; font-size:1rem;">${u.username}</div>
                        <div class="text-muted">${u.full_name || 'Sin Nombre'}</div>
                    </td>
                    <td>${roleBadge}</td>
                    <td>
                        <select id="ctype-${u.id}" class="tabler-select" style="max-width: 200px;">
                            <option value="PERCENT" ${cType==='PERCENT'?'selected':''}>% de la Ganancia Neta</option>
                            <option value="PERCENT_SALES" ${cType==='PERCENT_SALES'?'selected':''}>% de la Venta Total</option>
                            <option value="FIXED" ${cType==='FIXED'?'selected':''}>Cuota Fija Diaria ($ USD)</option>
                        </select>
                    </td>
                    <td>
                        <div style="display:flex; align-items:center; gap:5px; max-width: 150px;">
                            <input type="number" id="cval-${u.id}" class="tabler-input font-mono" value="${cVal}" step="0.01" min="0">
                        </div>
                    </td>
                    <td class="text-center">
                        <button class="tabler-btn btn-primary save-comm-btn" data-id="${u.id}"><i class="fas fa-save"></i> Guardar</button>
                    </td>
                </tr>
                `;
            }).join('');

            container.querySelectorAll('.save-comm-btn').forEach(btn => {
                btn.addEventListener('click', async () => {
                    const uid = btn.dataset.id;
                    const type = document.getElementById(`ctype-${uid}`).value;
                    const val = parseFloat(document.getElementById(`cval-${uid}`).value) || 0;

                    const orig = btn.innerHTML; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'; btn.disabled = true;
                    try {
                        await api.put('/configs/cashier', { user_id: parseInt(uid), commission_type: type, commission_value: val });
                        Notification(notificationContainer, 'Comisión actualizada exitosamente.', 'success');
                        // ⭐ FIX UI: Se recarga la tabla automáticamente para verificar que el servidor guardó el valor
                        await loadCommissions(); 
                    } catch(e) { Notification(notificationContainer, e.message, 'error'); btn.innerHTML = orig; btn.disabled = false; } 
                });
            });

        } catch (e) { tbody.innerHTML = '<tr><td colspan="5" class="text-center text-red py-5">Error al cargar usuarios.</td></tr>'; }
    };

    container.querySelector('#refreshCommissions').onclick = loadCommissions;
    loadCommissions();
}

// =================================================================================
// 📥 1. GESTIÓN DE CAJA (RECARGAS Y RETIROS)
// =================================================================================
export async function renderWithdrawalsManagement(container, notificationContainer) {
    // Mantiene la funcionalidad intacta pero con estilos Tabler (Código idéntico al bloque anterior)
    container.innerHTML = `
        ${tablerStyles}
        <div class="tabler-card">
            <div class="tabler-header">
                <h3 class="tabler-title"><i class="fas fa-exchange-alt text-muted"></i> Gestión de Operaciones de Caja</h3>
                <button id="refreshTransactions" class="tabler-btn btn-outline"><i class="fas fa-sync-alt"></i> Actualizar</button>
            </div>
            
            <div class="tabler-body">
                <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 1rem; margin-bottom: 1.5rem;">
                    <div class="nav-tabs">
                        <button class="nav-tab active" data-type="DEPOSIT_REQUEST"><i class="fas fa-arrow-down" style="color: #34d399; margin-right: 5px;"></i> Recargas</button>
                        <button class="nav-tab" data-type="WITHDRAW_REQUEST"><i class="fas fa-arrow-up" style="color: #f87171; margin-right: 5px;"></i> Retiros</button>
                    </div>
                    
                    <div style="display: flex; align-items: center; gap: 0.5rem; background: #0f172a; padding: 0.25rem 0.5rem; border-radius: 6px; border: 1px solid #334155;">
                        <label style="font-size: 0.75rem; font-weight: 600; color: #94a3b8; text-transform: uppercase;">Estado:</label>
                        <select id="tx-status-filter" class="tabler-select" style="border: none; background: transparent; padding: 0.25rem; width: auto; font-weight: 600; box-shadow: none;">
                            <option value="PENDING">⏳ Pendientes</option>
                            <option value="APPROVED">✅ Aprobados</option>
                            <option value="REJECTED">❌ Rechazados</option>
                            <option value="ALL">📋 Todos</option>
                        </select>
                    </div>
                </div>

                <div class="tabler-table-container">
                    <table class="tabler-table">
                        <thead>
                            <tr>
                                <th>Transacción</th>
                                <th>Usuario / Cliente</th>
                                <th class="text-right">Monto (Bs)</th>
                                <th class="text-center">Estado</th>
                                <th>Detalles de Pago</th>
                                <th class="text-center">Acciones</th>
                            </tr>
                        </thead>
                        <tbody id="transactionsBody">
                            <tr><td colspan="6" class="text-center text-muted py-5">Cargando operaciones...</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `;

    let currentType = 'DEPOSIT_REQUEST';
    let currentStatus = 'PENDING';
    
    const tbody = container.querySelector('#transactionsBody');
    const statusFilter = container.querySelector('#tx-status-filter');
    const tabs = container.querySelectorAll('.nav-tab');

    tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
            tabs.forEach(t => t.classList.remove('active'));
            e.currentTarget.classList.add('active');
            currentType = e.currentTarget.getAttribute('data-type');
            loadTransactions();
        });
    });

    statusFilter.addEventListener('change', (e) => {
        currentStatus = e.target.value;
        loadTransactions();
    });

    const loadTransactions = async () => {
        tbody.innerHTML = '<tr><td colspan="6" class="text-center text-muted py-5"><i class="fas fa-spinner fa-spin"></i> Cargando...</td></tr>';
        try {
            let url = `/remate/transactions?type=${currentType}`;
            if (currentStatus !== 'ALL') url += `&status=${currentStatus}`;
            const transactions = await api.get(url);
            
            if(!transactions || transactions.length === 0) {
                tbody.innerHTML = `<tr><td colspan="6" class="text-center text-muted py-5">No se encontraron operaciones bajo estos filtros.</td></tr>`;
                return;
            }

            tbody.innerHTML = transactions.map(t => {
                const isDeposit = t.type === 'DEPOSIT_REQUEST';
                const sign = isDeposit ? '+' : '-';
                const amountVal = parseFloat(t.amount).toLocaleString('es-VE', { minimumFractionDigits: 2 });
                const dateStr = new Date(t.created_at).toLocaleString('es-VE', {day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit'});
                
                let statusBadge = '';
                if(t.status === 'PENDING') statusBadge = '<span class="tabler-badge badge-yellow">⏳ Pendiente</span>';
                else if(t.status === 'APPROVED') statusBadge = '<span class="tabler-badge badge-green">✅ Aprobado</span>';
                else if(t.status === 'REJECTED') statusBadge = '<span class="tabler-badge badge-red">❌ Rechazado</span>';

                let actionsHtml = `<span class="text-muted">Procesado</span>`;
                if (t.status === 'PENDING') {
                    actionsHtml = `
                        <div style="display:flex; gap:0.5rem; justify-content:center;">
                            <button class="btn-icon-green approve-btn" data-id="${t.id}" data-type="${t.type}" title="Aprobar"><i class="fas fa-check"></i></button>
                            <button class="btn-icon-red reject-btn" data-id="${t.id}" data-type="${t.type}" title="Rechazar"><i class="fas fa-times"></i></button>
                        </div>
                    `;
                }

                return `
                <tr>
                    <td>
                        <div style="font-weight:600; color:#f8fafc;">#${t.id}</div>
                        <div class="text-muted">${dateStr}</div>
                    </td>
                    <td>
                        <div style="font-weight:600; color:#cbd5e1;">${t.user_alias || t.user_username}</div>
                        <div class="text-muted">ID: ${t.user_id}</div>
                    </td>
                    <td class="text-right font-mono" style="color: ${isDeposit ? '#34d399' : '#f87171'}; font-weight: 600; font-size: 1rem;">
                        ${sign} Bs ${amountVal}
                    </td>
                    <td class="text-center">${statusBadge}</td>
                    <td style="max-width:300px; white-space: normal;">
                        <div style="font-weight:500; font-size: 0.85rem;">${t.description || ''}</div>
                        ${t.reference ? `<div class="font-mono text-muted" style="margin-top:0.25rem;">Ref: ${t.reference}</div>` : ''}
                    </td>
                    <td class="text-center">${actionsHtml}</td>
                </tr>
                `;
            }).join('');

            attachActionListeners();
        } catch(e) {
            tbody.innerHTML = '<tr><td colspan="6" class="text-center text-red py-5">Error de red al cargar transacciones.</td></tr>';
        }
    };

    const attachActionListeners = () => {
        container.querySelectorAll('.approve-btn').forEach(btn => {
            btn.addEventListener('click', async () => {
                const typeText = btn.dataset.type === 'DEPOSIT_REQUEST' ? 'RECARGA' : 'RETIRO';
                if(!confirm(`¿Aprobar financieramente esta ${typeText}?`)) return;
                const orig = btn.innerHTML; btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
                try {
                    await api.post(`/remate/transactions/${btn.dataset.id}/resolve`, { action: 'APPROVE' });
                    Notification(notificationContainer, `${typeText} aprobada.`, 'success');
                    loadTransactions();
                } catch(e) { Notification(notificationContainer, e.message, 'error'); btn.disabled = false; btn.innerHTML = orig; }
            });
        });

        container.querySelectorAll('.reject-btn').forEach(btn => {
            btn.addEventListener('click', async () => {
                const typeText = btn.dataset.type === 'DEPOSIT_REQUEST' ? 'RECARGA' : 'RETIRO';
                if(!confirm(`¿Rechazar ${typeText}? (Si es un retiro, se DEVOLVERÁ el saldo retenido al cliente).`)) return;
                const orig = btn.innerHTML; btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
                try {
                    await api.post(`/remate/transactions/${btn.dataset.id}/resolve`, { action: 'REJECT' });
                    Notification(notificationContainer, `${typeText} rechazada.`, 'success');
                    loadTransactions();
                } catch(e) { Notification(notificationContainer, e.message, 'error'); btn.disabled = false; btn.innerHTML = orig; }
            });
        });
    };

    container.querySelector('#refreshTransactions').onclick = loadTransactions;
    loadTransactions(); 
}

// =================================================================================
// 🧾 2. REPORTE DE TICKETS (TAQUILLA FÍSICA) - FIX FILTRO "ALL" Y BATCHING
// =================================================================================
export async function renderTaquillaReports(container, notificationContainer) {
    await loadApexCharts();
    let chartInstance = null;

    container.innerHTML = `
        ${tablerStyles}
        <div class="tabler-card">
            <div class="tabler-header">
                <h3 class="tabler-title"><i class="fas fa-receipt text-muted"></i> Consolidado de Taquillas Físicas</h3>
            </div>
            
            <div class="tabler-body">
                <div class="filter-grid">
                    <div class="filter-group"><label>Desde</label><input type="date" id="taq-start" class="tabler-input"></div>
                    <div class="filter-group"><label>Hasta</label><input type="date" id="taq-end" class="tabler-input"></div>
                    <div class="filter-group"><label>Taquilla (Cajero)</label><select id="taq-user" class="tabler-select"><option value="ALL">-- Todas --</option></select></div>
                    <div class="filter-group"><label>Hipódromo</label><select id="taq-track" class="tabler-select"><option value="ALL">-- Todos --</option></select></div>
                    <div class="filter-group"><label>Estado</label><select id="taq-status" class="tabler-select"><option value="ALL">Todos (No Anulados)</option><option value="paid">Pagados</option><option value="unpaid">Pendientes</option><option value="voided">Anulados</option></select></div>
                    <button id="btn-gen-taq" class="tabler-btn btn-primary" style="height: 38px;"><i class="fas fa-search"></i> Filtrar Data</button>
                </div>

                <div id="taq-results" class="hidden">
                    <div class="widget-grid">
                        <div class="widget-card">
                            <div class="widget-title">Venta Bruta (USD)</div>
                            <div class="widget-value" id="wdg-taq-jugado">$0.00</div>
                        </div>
                        <div class="widget-card red">
                            <div class="widget-title">Premios Pagados</div>
                            <div class="widget-value" id="wdg-taq-pagado">$0.00</div>
                        </div>
                        <div class="widget-card green">
                            <div class="widget-title">Utilidad Casa (Neto)</div>
                            <div class="widget-value" id="wdg-taq-neto">$0.00</div>
                        </div>
                        <div class="widget-card purple">
                            <div class="widget-title">Total Comisiones</div>
                            <div class="widget-value" id="wdg-taq-comision">$0.00</div>
                        </div>
                    </div>

                    <div style="background: #0f172a; padding: 15px; border-radius: 8px; border: 1px solid #334155; margin-bottom: 1.5rem;">
                        <h4 style="color: #94a3b8; font-size: 0.85rem; text-transform: uppercase; margin-top:0;">Rendimiento por Taquilla</h4>
                        <div id="taq-chart" style="min-height: 250px;"></div>
                    </div>

                    <div class="tabler-table-container">
                        <table class="tabler-table">
                            <thead>
                                <tr>
                                    <th>Cajero / Taquilla</th>
                                    <th>Operador Asignado</th>
                                    <th class="text-center">TKTs</th>
                                    <th class="text-right">Venta Dólares</th>
                                    <th class="text-right">Venta Bs (Conv.)</th>
                                    <th class="text-right">Total Pagado</th>
                                    <th class="text-right">Neto Casa</th>
                                    <th class="text-right">Comisión a Pagar</th>
                                </tr>
                            </thead>
                            <tbody id="taq-body"></tbody>
                            <tfoot id="taq-footer"></tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    `;

    const startInput = container.querySelector('#taq-start');
    const endInput = container.querySelector('#taq-end');
    const userSelect = container.querySelector('#taq-user');
    const trackSelect = container.querySelector('#taq-track');
    const statusSelect = container.querySelector('#taq-status');
    const btnGen = container.querySelector('#btn-gen-taq');
    const resultsContainer = container.querySelector('#taq-results');
    const tbody = container.querySelector('#taq-body');
    const tfoot = container.querySelector('#taq-footer');

    const today = new Date();
    const monday = new Date(today); monday.setDate(monday.getDate() - monday.getDay() + (monday.getDay() === 0 ? -6 : 1));
    startInput.value = monday.toISOString().split('T')[0]; endInput.value = today.toISOString().split('T')[0];

    let cashiersList = [];
    const cashierMap = new Map();

    const loadInitialData = async () => {
        try {
            const [tracksRes, usersRes] = await Promise.all([
                api.get('/tracks?admin_mode=true'),
                api.get('/users')
            ]);
            
            const tracks = tracksRes.tracks || tracksRes;
            if (Array.isArray(tracks)) {
                tracks.forEach(t => trackSelect.appendChild(new Option(t.name, t.id)));
            }

            const cashiers = usersRes.filter(u => u.role === 'cashier' || u.role === 'admin' || u.role === 'payout_agent');
            cashiersList = cashiers; 
            
            cashiers.forEach(u => cashierMap.set(u.id, u));
            cashiers.forEach(u => userSelect.appendChild(new Option(`${u.username} ${u.full_name ? '('+u.full_name+')':''}`, u.id)));
        } catch (e) { console.error("Error inicial", e); }
    };

    // ⭐ HELPER: Motor de Descarga Paginada para evadir el Error 53300 (Too many clients)
    async function fetchTicketsBatchedSafe(baseParams, progressText) {
        let allTkts = [];
        let page = 1;
        const limit = 100;
        let hasMore = true;

        btnGen.innerHTML = `<i class="fas fa-spinner fa-spin"></i> ${progressText} (Lote 1)...`;

        while (hasMore) {
            const p = new URLSearchParams(baseParams);
            p.append('limit', limit);
            p.append('page', page);
            
            try {
                const res = await api.get(`/tickets?${p.toString()}`);
                const batch = res.tickets || res || [];
                
                if (!Array.isArray(batch) || batch.length === 0) {
                    hasMore = false;
                } else {
                    allTkts = allTkts.concat(batch);
                    if (batch.length < limit) hasMore = false;
                    else {
                        page++;
                        btnGen.innerHTML = `<i class="fas fa-spinner fa-spin"></i> ${progressText} (Lote ${page})...`;
                    }
                }
            } catch(e) {
                console.error("Batching failed:", e);
                hasMore = false;
            }
        }
        return allTkts;
    }

    btnGen.addEventListener('click', async () => {
        if (!startInput.value || !endInput.value) return Notification(notificationContainer, 'Fechas requeridas.', 'error');
        
        const origText = btnGen.innerHTML; btnGen.disabled = true;

        try {
            const baseParams = new URLSearchParams();
            baseParams.append('start_date', `${startInput.value} 00:00:00`);
            baseParams.append('end_date', `${endInput.value} 23:59:59`);
            
            if (trackSelect.value !== 'ALL') baseParams.append('track_id', trackSelect.value);
            if (statusSelect.value !== 'ALL') baseParams.append('status', statusSelect.value);

            let tickets = [];
            const [configData] = await Promise.all([api.get('/configs/cashier')]);
            
            // ⭐ POKA-YOKE: Extracción serializada en lugar de paralela masiva
            if (userSelect.value === 'ALL') {
                for (let i = 0; i < cashiersList.length; i++) {
                    const c = cashiersList[i];
                    const p = new URLSearchParams(baseParams.toString());
                    p.append('cashier_id', c.id);
                    
                    const cTickets = await fetchTicketsBatchedSafe(p, `Auditando cajero ${i+1}/${cashiersList.length}`);
                    tickets = tickets.concat(cTickets);
                }
            } else {
                baseParams.append('cashier_id', userSelect.value);
                tickets = await fetchTicketsBatchedSafe(baseParams, 'Extrayendo tickets');
            }

            const configsArr = Array.isArray(configData) ? configData : [configData];
            const globalRateObj = configsArr.find(c => c.user_id === 1) || configsArr[0] || {};
            const globalRate = parseFloat(globalRateObj.exchange_rate) || 1; 

            const reportMap = new Map();

            // Garantizamos que todos los cajeros aparezcan en 0, incluso si no vendieron nada hoy
            if (userSelect.value === 'ALL') {
                cashiersList.forEach(c => {
                    const opConf = configsArr.find(conf => conf.user_id === c.id) || {};
                    reportMap.set(c.id, {
                        username: c.username, full_name: c.full_name, ally_name: c.ally_name || 'Directo (Sin Operador)',
                        comType: opConf.commission_type || 'PERCENT', comVal: parseFloat(opConf.commission_value || 0),
                        tkts: 0, jugadoUsd: 0, jugadoBsConv: 0, pagado: 0
                    });
                });
            }

            tickets.forEach(t => {
                const cId = t.cashier_id;
                if (!reportMap.has(cId)) {
                    const cInfo = cashierMap.get(cId) || { username: `ID ${cId}`, full_name: '', ally_name: 'N/A' };
                    const opConf = configsArr.find(c => c.user_id === cId) || {};
                    reportMap.set(cId, {
                        username: cInfo.username, full_name: cInfo.full_name, ally_name: cInfo.ally_name || 'Directo (Sin Operador)',
                        comType: opConf.commission_type || 'PERCENT', comVal: parseFloat(opConf.commission_value || 0),
                        tkts: 0, jugadoUsd: 0, jugadoBsConv: 0, pagado: 0
                    });
                }

                const row = reportMap.get(cId);
                let rawAmount = parseFloat(t.amount) || 0;
                let rawPaid = parseFloat(t.paid_amount) || 0;

                if (t.currency === 'VES') {
                    row.jugadoBsConv += (rawAmount / globalRate);
                    rawPaid = rawPaid / globalRate;
                } else {
                    row.jugadoUsd += rawAmount;
                }

                if (t.status !== 'voided') {
                    row.tkts++;
                    row.pagado += rawPaid;
                }
            });

            resultsContainer.classList.remove('hidden');

            if (reportMap.size === 0) {
                tbody.innerHTML = '<tr><td colspan="8" class="text-center text-muted py-4">No hay información de taquillas disponible.</td></tr>';
                tfoot.innerHTML = ''; 
                if(chartInstance) chartInstance.destroy();
                return;
            }

            let gTkts = 0, gUsd = 0, gBs = 0, gPaid = 0, gNeto = 0, gCom = 0;
            let chartCategories = []; let chartSales = []; let chartCommissions = [];

            const reportRows = Array.from(reportMap.values())
                .filter(r => (r.jugadoUsd + r.jugadoBsConv) > 0)
                .sort((a,b) => (b.jugadoUsd + b.jugadoBsConv) - (a.jugadoUsd + a.jugadoBsConv));

            if (reportRows.length === 0) {
                 tbody.innerHTML = '<tr><td colspan="8" class="text-center text-muted py-4">Las taquillas no registran ventas en este periodo.</td></tr>';
                 tfoot.innerHTML = ''; 
                 if(chartInstance) chartInstance.destroy();
                 return;
            }

            tbody.innerHTML = reportRows.map(r => {
                const totalJugado = r.jugadoUsd + r.jugadoBsConv;
                const neto = totalJugado - r.pagado;
                
                let comision = 0;
                let comText = '';
                if (r.comType === 'PERCENT') { comision = neto > 0 ? neto * (r.comVal / 100) : 0; comText = `${r.comVal}% Neto`; } 
                else if (r.comType === 'PERCENT_SALES') { comision = totalJugado * (r.comVal / 100); comText = `${r.comVal}% Venta`; } 
                else if (r.comType === 'FIXED') { comision = r.comVal; comText = `Fijo $${r.comVal}`; }

                gTkts += r.tkts; gUsd += r.jugadoUsd; gBs += r.jugadoBsConv; gPaid += r.pagado; gNeto += neto; gCom += comision;

                chartCategories.push(r.username);
                chartSales.push(parseFloat(totalJugado.toFixed(2)));
                chartCommissions.push(parseFloat(comision.toFixed(2)));

                return `
                <tr>
                    <td><div style="font-weight:600; color:#f8fafc;">${r.username}</div><div class="text-muted">${r.full_name || 'Taquilla'}</div></td>
                    <td><span class="tabler-badge badge-gray"><i class="fas fa-briefcase"></i> ${r.ally_name}</span></td>
                    <td class="text-center font-mono font-weight-bold">${r.tkts}</td>
                    <td class="text-right font-mono">$${r.jugadoUsd.toFixed(2)}</td>
                    <td class="text-right font-mono">$${r.jugadoBsConv.toFixed(2)}</td>
                    <td class="text-right font-mono text-muted">$${r.pagado.toFixed(2)}</td>
                    <td class="text-right font-mono" style="font-weight:600; color:${neto>=0?'#34d399':'#f87171'};">${neto>=0?'+':''}$${neto.toFixed(2)}</td>
                    <td class="text-right">
                        <div class="font-mono" style="font-weight:700; color:#60a5fa; font-size:1.05rem;">$${comision.toFixed(2)}</div>
                        <div class="text-muted font-mono" style="font-size:0.7rem;">(${comText})</div>
                    </td>
                </tr>
                `;
            }).join('');

            tfoot.innerHTML = `
                <tr>
                    <td colspan="2" class="text-right text-muted">TOTALES CONSOLIDADOS (USD):</td>
                    <td class="text-center font-mono">${gTkts}</td>
                    <td class="text-right font-mono">$${gUsd.toFixed(2)}</td>
                    <td class="text-right font-mono">$${gBs.toFixed(2)}</td>
                    <td class="text-right font-mono">$${gPaid.toFixed(2)}</td>
                    <td class="text-right font-mono" style="color:${gNeto>=0?'#34d399':'#f87171'};">${gNeto>=0?'+':''}$${gNeto.toFixed(2)}</td>
                    <td class="text-right font-mono" style="color:#60a5fa; font-size:1.15rem;">$${gCom.toFixed(2)}</td>
                </tr>
            `;

            container.querySelector('#wdg-taq-jugado').innerText = `$${(gUsd + gBs).toFixed(2)}`;
            container.querySelector('#wdg-taq-pagado').innerText = `$${gPaid.toFixed(2)}`;
            container.querySelector('#wdg-taq-neto').innerText = `$${gNeto.toFixed(2)}`;
            container.querySelector('#wdg-taq-comision').innerText = `$${gCom.toFixed(2)}`;

            if (chartInstance) chartInstance.destroy();
            const options = {
                chart: { type: 'bar', height: 300, toolbar: { show: false }, background: 'transparent', foreColor: '#94a3b8' },
                series: [{ name: 'Ventas Totales USD', data: chartSales }, { name: 'Comisión USD', data: chartCommissions }],
                xaxis: { categories: chartCategories },
                colors: ['#3b82f6', '#8b5cf6'],
                theme: { mode: 'dark' },
                plotOptions: { bar: { borderRadius: 4, horizontal: false, columnWidth: '55%' } },
                dataLabels: { enabled: false },
                stroke: { show: true, width: 2, colors: ['transparent'] }
            };
            chartInstance = new ApexCharts(document.querySelector("#taq-chart"), options);
            chartInstance.render();

        } catch (e) { Notification(notificationContainer, e.message, 'error'); } 
        finally { btnGen.innerHTML = '<i class="fas fa-search"></i> Filtrar Data'; btnGen.disabled = false; }
    });

    await loadInitialData();
}

// =================================================================================
// 📈 4. DASHBOARD EJECUTIVO DE AUDITORÍA (RESUMEN GLOBAL Y UTILIDAD NETA)
// =================================================================================
export async function renderExecutiveDashboard(container, notificationContainer) {
    await loadApexCharts();

    container.innerHTML = `
        ${tablerStyles}
        <div class="tabler-card">
            <div class="tabler-header">
                <h3 class="tabler-title"><i class="fas fa-chart-line text-muted"></i> Panel de Auditoría y Rendimiento</h3>
            </div>
            
            <div class="tabler-body">
                <div class="filter-grid">
                    <div class="filter-group"><label>Desde</label><input type="date" id="exec-start" class="tabler-input"></div>
                    <div class="filter-group"><label>Hasta</label><input type="date" id="exec-end" class="tabler-input"></div>
                    <button id="btn-gen-exec" class="tabler-btn btn-primary" style="height: 38px;"><i class="fas fa-search"></i> Analizar Operación</button>
                </div>

                <div id="exec-results" class="hidden">
                    
                    <!-- RESUMEN FINANCIERO GLOBAL -->
                    <h4 style="color: #D4AF37; margin-top:0; margin-bottom:1rem; font-size:1.1rem; text-transform:uppercase;">1. Consolidado Financiero (Global)</h4>
                    <div class="widget-grid" style="grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));">
                        <div class="widget-card">
                            <div class="widget-title">Gross Handle (Venta Bruta)</div>
                            <div class="widget-value text-blue-400" id="exec-handle">$0.00</div>
                        </div>
                        <div class="widget-card red">
                            <div class="widget-title">Premios Pagados</div>
                            <div class="widget-value text-red-400" id="exec-payouts">$0.00</div>
                        </div>
                        <div class="widget-card purple">
                            <div class="widget-title">GGR (Utilidad Bruta Casa)</div>
                            <div class="widget-value text-purple-400" id="exec-ggr">$0.00</div>
                        </div>
                    </div>

                    <!-- RESUMEN DE UTILIDAD REAL (LO QUE LE QUEDA A LA CASA) -->
                    <div class="widget-grid" style="grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); margin-bottom: 2rem;">
                        <div class="widget-card" style="background: rgba(245, 158, 11, 0.05); border-color: #f59e0b;">
                            <div class="widget-title" style="color: #f59e0b;">Comisiones a Pagar (Operadores)</div>
                            <div class="widget-value text-yellow-400" id="exec-commissions">$0.00</div>
                        </div>
                        <div class="widget-card green" style="background: rgba(16, 185, 129, 0.05); border-color: #10b981;">
                            <div class="widget-title" style="color: #10b981;">Utilidad Neta Real (Tu Ganancia)</div>
                            <div class="widget-value text-green-400" id="exec-net-profit">$0.00</div>
                        </div>
                        <div class="widget-card blue">
                            <div class="widget-title">Hold Real (Retención %)</div>
                            <div class="widget-value text-blue-400" id="exec-hold">0.00%</div>
                        </div>
                    </div>

                    <!-- DESGLOSE POR CANAL -->
                    <div style="display:grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 1.5rem; margin-bottom: 2rem;">
                        <!-- Tarjeta FÍSICA -->
                        <div style="background:#0f172a; padding:1.5rem; border-radius:8px; border:1px solid #334155;">
                            <h5 style="color:#f8fafc; font-size:1rem; margin-top:0; border-bottom:1px solid #334155; padding-bottom:0.5rem;"><i class="fas fa-desktop text-yellow-500"></i> Producción Taquillas</h5>
                            <div style="display:flex; justify-content:space-between; margin-top:1rem;">
                                <span class="text-muted">Venta:</span><span class="font-mono font-bold text-white" id="phys-sales">$0.00</span>
                            </div>
                            <div style="display:flex; justify-content:space-between; margin-top:0.5rem;">
                                <span class="text-muted">Premios:</span><span class="font-mono font-bold text-red-400" id="phys-paid">$0.00</span>
                            </div>
                            <div style="display:flex; justify-content:space-between; margin-top:0.5rem;">
                                <span class="text-muted">Anulaciones:</span><span class="font-mono font-bold text-gray-400" id="phys-void">$0.00</span>
                            </div>
                            <div style="display:flex; justify-content:space-between; margin-top:1rem; padding-top:0.5rem; border-top:1px dashed #334155;">
                                <span class="text-muted">Tickets Emitidos:</span><span class="font-mono font-bold text-blue-400" id="phys-count">0</span>
                            </div>
                        </div>

                        <!-- Tarjeta DIGITAL -->
                        <div style="background:#0f172a; padding:1.5rem; border-radius:8px; border:1px solid #334155;">
                            <h5 style="color:#f8fafc; font-size:1rem; margin-top:0; border-bottom:1px solid #334155; padding-bottom:0.5rem;"><i class="fas fa-mobile-alt text-blue-500"></i> Producción App / Digital</h5>
                            <div style="display:flex; justify-content:space-between; margin-top:1rem;">
                                <span class="text-muted">Venta W/P y Remate:</span><span class="font-mono font-bold text-white" id="dig-sales">$0.00</span>
                            </div>
                            <div style="display:flex; justify-content:space-between; margin-top:0.5rem;">
                                <span class="text-muted">Premios:</span><span class="font-mono font-bold text-red-400" id="dig-paid">$0.00</span>
                            </div>
                            <div style="display:flex; justify-content:space-between; margin-top:0.5rem;">
                                <span class="text-muted">Anulaciones (Scratches):</span><span class="font-mono font-bold text-gray-400" id="dig-void">$0.00</span>
                            </div>
                            <div style="display:flex; justify-content:space-between; margin-top:1rem; padding-top:0.5rem; border-top:1px dashed #334155;">
                                <span class="text-muted">Salas de Remate Activas:</span><span class="font-mono font-bold text-purple-400" id="dig-rooms">0</span>
                            </div>
                        </div>
                    </div>

                    <!-- TABLAS DE RIESGO Y RENDIMIENTO -->
                    <div style="display:grid; grid-template-columns: repeat(auto-fit, minmax(400px, 1fr)); gap: 1.5rem;">
                        
                        <!-- Rendimiento por Hipódromo -->
                        <div>
                            <h4 style="color: #D4AF37; margin-top:0; margin-bottom:1rem; font-size:1.1rem; text-transform:uppercase;">2. Volumen por Hipódromo</h4>
                            <div class="tabler-table-container" style="border:1px solid #334155; border-radius:8px;">
                                <table class="tabler-table">
                                    <thead><tr><th>Hipódromo</th><th class="text-right">Volumen (USD)</th><th class="text-right">% del Total</th></tr></thead>
                                    <tbody id="exec-track-body"></tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Análisis de Riesgo (Liability) -->
                        <div>
                            <h4 style="color: #ef4444; margin-top:0; margin-bottom:1rem; font-size:1.1rem; text-transform:uppercase;"><i class="fas fa-exclamation-triangle"></i> Análisis de Riesgo (Top Ejemplares)</h4>
                            <p class="text-muted" style="margin-bottom:10px;">Caballos con mayor cantidad de dinero apostado en la plataforma. Útil para medir exposición de la casa.</p>
                            <div class="tabler-table-container" style="border:1px solid #334155; border-radius:8px;">
                                <table class="tabler-table">
                                    <thead><tr><th>Ejemplar</th><th>Carrera</th><th class="text-right">Riesgo Acum.</th></tr></thead>
                                    <tbody id="exec-horse-body"></tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    `;

    const startInput = container.querySelector('#exec-start');
    const endInput = container.querySelector('#exec-end');
    const btnGen = container.querySelector('#btn-gen-exec');
    const resultsContainer = container.querySelector('#exec-results');

    const today = new Date();
    startInput.value = today.toISOString().split('T')[0];
    endInput.value = today.toISOString().split('T')[0];

    btnGen.addEventListener('click', async () => {
        if (!startInput.value || !endInput.value) return Notification(notificationContainer, 'Fechas requeridas.', 'error');
        
        const origText = btnGen.innerHTML; btnGen.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Auditando...'; btnGen.disabled = true;

        try {
            // ⭐ FIX: Instanciación segura de las variables de fecha en la URL para evitar errores HTTP
            const dateParams = new URLSearchParams({
                startDate: `${startInput.value} 00:00:00`,
                endDate: `${endInput.value} 23:59:59`
            });
            const tktParams = new URLSearchParams({
                start_date: `${startInput.value} 00:00:00`,
                end_date: `${endInput.value} 23:59:59`
            });

            const [digitalData, configData, systemUsers] = await Promise.all([
                api.get(`/remate/reports/detailed-bets?${dateParams.toString()}`).catch(()=>[]),
                api.get('/configs/cashier').catch(()=>[]),
                api.get('/users').catch(()=>[])
            ]);

            const cashiers = systemUsers.filter(u => u.role === 'cashier' || u.role === 'admin' || u.role === 'payout_agent');
            
            const ticketPromises = cashiers.map(c => {
                const localParams = new URLSearchParams(tktParams.toString());
                localParams.append('cashier_id', c.id);
                return api.get(`/tickets?${localParams.toString()}`).catch(() => []);
            });
            
            const nestedTickets = await Promise.all(ticketPromises);
            const ticketsData = nestedTickets.map(res => Array.isArray(res) ? res : []).flat();

            const configsArr = Array.isArray(configData) ? configData : [configData];
            const globalRateObj = configsArr.find(c => c.user_id === 1) || {};
            const globalRate = parseFloat(globalRateObj.exchange_rate) || 1;

            let physSales = 0, physPaid = 0, physVoid = 0, physCount = 0;
            let digSales = 0, digPaid = 0, digVoid = 0;
            const activeRooms = new Set();
            const trackVolume = new Map();
            const horseLiability = new Map();

            const physByCashier = new Map();
            const digByAlly = new Map();

            // PROCESAR TICKETS FÍSICOS
            ticketsData.forEach(t => {
                let amountUSD = parseFloat(t.amount) || 0;
                let paidUSD = parseFloat(t.paid_amount) || 0;

                if (t.currency === 'VES') {
                    amountUSD = amountUSD / globalRate;
                    paidUSD = paidUSD / globalRate;
                }

                if (t.status === 'voided') {
                    physVoid += amountUSD;
                } else {
                    physCount++;
                    physSales += amountUSD;
                    physPaid += paidUSD;
                    
                    const tName = t.track_name || 'Hipódromo Físico';
                    trackVolume.set(tName, (trackVolume.get(tName) || 0) + amountUSD);

                    const cId = t.cashier_id;
                    if(!physByCashier.has(cId)) physByCashier.set(cId, { sales: 0, paid: 0 });
                    physByCashier.get(cId).sales += amountUSD;
                    physByCashier.get(cId).paid += paidUSD;
                }
            });

            // PROCESAR APUESTAS DIGITALES 
            digitalData.forEach(b => {
                const amount = parseFloat(b.amount) || 0;
                const payout = parseFloat(b.payout) || 0;
                
                if (b.status === 'scratched' || b.status === 'refunded') {
                    digVoid += amount;
                } else {
                    digSales += amount;
                    digPaid += payout;

                    if (b.category === 'REMATE' && b.room_name) activeRooms.add(b.room_name);

                    const tName = b.track_name || 'Desconocido';
                    trackVolume.set(tName, (trackVolume.get(tName) || 0) + amount);

                    const hKey = `${b.horse_name} (C${b.race_number})`;
                    horseLiability.set(hKey, (horseLiability.get(hKey) || 0) + amount);

                    const ally = b.ally_name || 'Directo';
                    if(!digByAlly.has(ally)) digByAlly.set(ally, { sales: 0, paid: 0 });
                    digByAlly.get(ally).sales += amount;
                    digByAlly.get(ally).paid += payout;
                }
            });

            // CÁLCULO DE COMISIONES GLOBALES
            let totalCommissions = 0;

            for (const [cId, data] of physByCashier.entries()) {
                const opConf = configsArr.find(c => c.user_id === cId) || {};
                const neto = data.sales - data.paid;
                const cType = opConf.commission_type || 'PERCENT';
                const cVal = parseFloat(opConf.commission_value || 0);
                
                if (cType === 'PERCENT' && neto > 0) totalCommissions += (neto * (cVal / 100));
                else if (cType === 'PERCENT_SALES') totalCommissions += (data.sales * (cVal / 100));
                else if (cType === 'FIXED' && data.sales > 0) totalCommissions += cVal; // Solo cobra cuota fija si vendió algo
            }

            for (const [ally, data] of digByAlly.entries()) {
                if (ally !== 'Directo') {
                    const allyUser = systemUsers.find(u => u.username === ally);
                    if (allyUser) {
                        const opConf = configsArr.find(c => c.user_id === allyUser.id) || {};
                        const neto = data.sales - data.paid;
                        const cType = opConf.commission_type || 'PERCENT';
                        const cVal = parseFloat(opConf.commission_value || 0);
                        
                        if (cType === 'PERCENT' && neto > 0) totalCommissions += (neto * (cVal / 100));
                        else if (cType === 'PERCENT_SALES') totalCommissions += (data.sales * (cVal / 100));
                        else if (cType === 'FIXED' && data.sales > 0) totalCommissions += cVal;
                    }
                }
            }

            const totalHandle = physSales + digSales;
            const totalPayouts = physPaid + digPaid;
            const ggr = totalHandle - totalPayouts; 
            const realNetProfit = ggr - totalCommissions; 
            const holdPercent = totalHandle > 0 ? (realNetProfit / totalHandle) * 100 : 0;

            container.querySelector('#exec-handle').innerText = `$${totalHandle.toFixed(2)}`;
            container.querySelector('#exec-payouts').innerText = `$${totalPayouts.toFixed(2)}`;
            container.querySelector('#exec-ggr').innerText = `$${ggr.toFixed(2)}`;
            
            container.querySelector('#exec-commissions').innerText = `$${totalCommissions.toFixed(2)}`;
            container.querySelector('#exec-net-profit').innerText = `$${realNetProfit.toFixed(2)}`;
            container.querySelector('#exec-hold').innerText = `${holdPercent.toFixed(2)}%`;

            container.querySelector('#phys-sales').innerText = `$${physSales.toFixed(2)}`;
            container.querySelector('#phys-paid').innerText = `$${physPaid.toFixed(2)}`;
            container.querySelector('#phys-void').innerText = `$${physVoid.toFixed(2)}`;
            container.querySelector('#phys-count').innerText = physCount;

            container.querySelector('#dig-sales').innerText = `$${digSales.toFixed(2)}`;
            container.querySelector('#dig-paid').innerText = `$${digPaid.toFixed(2)}`;
            container.querySelector('#dig-void').innerText = `$${digVoid.toFixed(2)}`;
            container.querySelector('#dig-rooms').innerText = activeRooms.size;

            const sortedTracks = Array.from(trackVolume.entries()).sort((a,b) => b[1] - a[1]);
            container.querySelector('#exec-track-body').innerHTML = sortedTracks.map(t => {
                const percentage = totalHandle > 0 ? (t[1] / totalHandle) * 100 : 0;
                return `<tr>
                    <td class="font-bold text-white">${t[0]}</td>
                    <td class="text-right font-mono">$${t[1].toFixed(2)}</td>
                    <td class="text-right font-mono text-muted">${percentage.toFixed(1)}%</td>
                </tr>`;
            }).join('') || '<tr><td colspan="3" class="text-center text-muted">Sin datos de volumen</td></tr>';

            const sortedHorses = Array.from(horseLiability.entries()).sort((a,b) => b[1] - a[1]).slice(0, 10);
            container.querySelector('#exec-horse-body').innerHTML = sortedHorses.map(h => {
                return `<tr>
                    <td class="font-bold" style="color: #fca5a5;">${h[0].split(' (')[0]}</td>
                    <td class="text-muted">${h[0].split(' (')[1].replace(')','')}</td>
                    <td class="text-right font-mono" style="color: #ef4444; font-weight: 600;">$${h[1].toFixed(2)}</td>
                </tr>`;
            }).join('') || '<tr><td colspan="3" class="text-center text-muted">Sin exposición de riesgo registrada</td></tr>';

            resultsContainer.classList.remove('hidden');

        } catch (e) { Notification(notificationContainer, e.message, 'error'); } 
        finally { btnGen.innerHTML = '<i class="fas fa-search"></i> Analizar Operación'; btnGen.disabled = false; }
    });
}

// =================================================================================
// 📱 3. REPORTE DE APUESTAS DIGITALES (APP WIN/PLACE) - DOLARIZADO CON GRÁFICOS
// =================================================================================
export async function renderReportsAnalytics(container, notificationContainer) {
    await loadApexCharts();
    let chartInstance = null;

    container.innerHTML = `
        ${tablerStyles}
        <div class="tabler-card">
            <div class="tabler-header">
                <h3 class="tabler-title"><i class="fas fa-mobile-alt text-muted"></i> Reporte Digital (App Win/Place)</h3>
            </div>
            
            <div class="tabler-body">
                <div class="filter-grid">
                    <div class="filter-group"><label>Desde</label><input type="date" id="dig-start" class="tabler-input"></div>
                    <div class="filter-group"><label>Hasta</label><input type="date" id="dig-end" class="tabler-input"></div>
                    <div class="filter-group"><label>Operador / Vendedor</label><select id="dig-ally" class="tabler-select"><option value="ALL">-- Todos --</option></select></div>
                    <div class="filter-group"><label>Hipódromo</label><select id="dig-track" class="tabler-select"><option value="ALL">-- Todos --</option></select></div>
                    <div class="filter-group"><label>Carrera</label><select id="dig-race" class="tabler-select" disabled><option value="ALL">-- Todas --</option></select></div>
                    <button id="btn-gen-dig" class="tabler-btn btn-primary" style="height: 38px;"><i class="fas fa-search"></i> Filtrar Data</button>
                </div>

                <div id="dig-results" class="hidden">
                    <div class="widget-grid">
                        <div class="widget-card">
                            <div class="widget-title">Jugado en App (USD)</div>
                            <div class="widget-value" id="wdg-dig-jugado">$0.00</div>
                        </div>
                        <div class="widget-card red">
                            <div class="widget-title">Premios App</div>
                            <div class="widget-value" id="wdg-dig-pagado">$0.00</div>
                        </div>
                        <div class="widget-card green">
                            <div class="widget-title">Utilidad Casa (Neto)</div>
                            <div class="widget-value" id="wdg-dig-neto">$0.00</div>
                        </div>
                        <div class="widget-card purple">
                            <div class="widget-title">Comisiones Operadores</div>
                            <div class="widget-value" id="wdg-dig-comision">$0.00</div>
                        </div>
                    </div>

                    <!-- Contenedor del Gráfico -->
                    <div style="background: #0f172a; padding: 15px; border-radius: 8px; border: 1px solid #334155; margin-bottom: 1.5rem;">
                        <h4 style="color: #94a3b8; font-size: 0.85rem; text-transform: uppercase; margin-top:0;">Producción por Operador VIP</h4>
                        <div id="dig-chart" style="min-height: 250px;"></div>
                    </div>

                    <div class="tabler-table-container">
                        <table class="tabler-table">
                            <thead>
                                <tr>
                                    <th>Operador Asignado</th>
                                    <th>Cliente App</th>
                                    <th class="text-right">Total Jugado (USD)</th>
                                    <th class="text-right">Premios Pagados</th>
                                    <th class="text-right">Neto Casa</th>
                                    <th class="text-right">Comisión del Operador</th>
                                </tr>
                            </thead>
                            <tbody id="dig-body"></tbody>
                            <tfoot id="dig-footer"></tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    `;

    const startInput = container.querySelector('#dig-start');
    const endInput = container.querySelector('#dig-end');
    const allySelect = container.querySelector('#dig-ally');
    const trackSelect = container.querySelector('#dig-track');
    const raceSelect = container.querySelector('#dig-race');
    const btnGen = container.querySelector('#btn-gen-dig');
    const resultsContainer = container.querySelector('#dig-results');
    const tbody = container.querySelector('#dig-body');
    const tfoot = container.querySelector('#dig-footer');

    const today = new Date();
    const monday = new Date(today); monday.setDate(monday.getDate() - monday.getDay() + (monday.getDay() === 0 ? -6 : 1));
    startInput.value = monday.toISOString().split('T')[0]; endInput.value = today.toISOString().split('T')[0];

    let systemUsers = [];

    const loadInitialData = async () => {
        try {
            const [tracksRes, usersRes, appUsers] = await Promise.all([
                api.get('/tracks?admin_mode=true'),
                api.get('/users'),
                api.get('/remate/users')
            ]);
            
            systemUsers = usersRes;
            const tracks = tracksRes.tracks || tracksRes;
            if (Array.isArray(tracks)) {
                tracks.forEach(t => trackSelect.appendChild(new Option(t.name, t.id)));
            }

            const allies = new Set();
            appUsers.forEach(u => { if (u.ally_name && u.ally_name.trim()) allies.add(u.ally_name.trim()); });
            
            allySelect.appendChild(new Option('Jugadores Directos (Sin Operador)', 'Directo (Sin Vendedor)'));
            allies.forEach(a => allySelect.appendChild(new Option(a, a)));

        } catch (e) { console.error("Error inicial", e); }
    };

    trackSelect.addEventListener('change', async () => {
        const tId = trackSelect.value;
        raceSelect.innerHTML = '<option value="ALL">-- Todas --</option>'; raceSelect.disabled = true;
        if (tId !== 'ALL') {
            try {
                const races = await api.get('/races', { params: { track_id: tId } });
                races.forEach(r => raceSelect.appendChild(new Option(`C${r.race_number} - ${r.name}`, r.id)));
                raceSelect.disabled = false;
            } catch (e) {}
        }
    });

    btnGen.addEventListener('click', async () => {
        if (!startInput.value || !endInput.value) return Notification(notificationContainer, 'Fechas requeridas.', 'error');
        
        const origText = btnGen.innerHTML; btnGen.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'; btnGen.disabled = true;

        try {
            const params = new URLSearchParams();
            params.append('startDate', `${startInput.value} 00:00:00`);
            params.append('endDate', `${endInput.value} 23:59:59`);
            
            if (allySelect.value !== 'ALL') params.append('allyName', allySelect.value);
            if (trackSelect.value !== 'ALL') params.append('trackId', trackSelect.value);
            if (raceSelect.value !== 'ALL') params.append('raceId', raceSelect.value);

            const [data, configData] = await Promise.all([
                api.get(`/remate/reports/digital-winplace?${params.toString()}`),
                api.get('/configs/cashier')
            ]);

            const configsArr = Array.isArray(configData) ? configData : [configData];

            resultsContainer.classList.remove('hidden');

            if (data.length === 0) {
                tbody.innerHTML = '<tr><td colspan="6" class="text-center text-muted py-4">No hubo actividad digital en estas fechas.</td></tr>';
                tfoot.innerHTML = ''; 
                if(chartInstance) chartInstance.destroy();
                return;
            }

            let gJug = 0, gPre = 0, gNeto = 0, gCom = 0;
            let allySalesMap = new Map(); // Para agrupar ventas por operador para el gráfico

            tbody.innerHTML = data.map(row => {
                const jugado = parseFloat(row.total_played);
                const premios = parseFloat(row.total_paid);
                const neto = jugado - premios;
                const operador = row.ally_name || 'Directo (Sin Operador)';
                
                let comision = 0; let comText = 'Directo';
                if (operador !== 'Directo (Sin Vendedor)') {
                    const allyUser = systemUsers.find(u => u.username === operador);
                    if (allyUser) {
                        const opConf = configsArr.find(c => c.user_id === allyUser.id) || {};
                        const comType = opConf.commission_type || 'PERCENT';
                        const comVal = parseFloat(opConf.commission_value || 0);

                        if (comType === 'PERCENT') { comision = neto > 0 ? neto * (comVal / 100) : 0; comText = `${comVal}% Neto`; } 
                        else if (comType === 'PERCENT_SALES') { comision = jugado * (comVal / 100); comText = `${comVal}% Venta`; } 
                        else if (comType === 'FIXED') { comision = comVal; comText = `Fijo $${comVal}`; }
                    }
                }

                gJug += jugado; gPre += premios; gNeto += neto; gCom += comision;

                // Agrupar para el gráfico
                if(!allySalesMap.has(operador)) allySalesMap.set(operador, { sales: 0, comm: 0 });
                allySalesMap.get(operador).sales += jugado;
                allySalesMap.get(operador).comm += comision;

                return `
                <tr>
                    <td><span class="tabler-badge badge-gray"><i class="fas fa-user-tie"></i> ${operador}</span></td>
                    <td>
                        <div style="font-weight:600; color:#f8fafc;">${row.alias || row.username}</div>
                        <div class="text-muted">${row.first_name || 'App Client'}</div>
                    </td>
                    <td class="text-right font-mono">$${jugado.toFixed(2)}</td>
                    <td class="text-right font-mono text-muted">$${premios.toFixed(2)}</td>
                    <td class="text-right font-mono" style="font-weight:600; color:${neto>=0?'#34d399':'#f87171'};">${neto>=0?'+':''}$${neto.toFixed(2)}</td>
                    <td class="text-right">
                        <div class="font-mono" style="font-weight:700; color:#60a5fa; font-size:1.05rem;">$${comision.toFixed(2)}</div>
                        <div class="text-muted font-mono" style="font-size:0.7rem;">(${comText})</div>
                    </td>
                </tr>
                `;
            }).join('');

            tfoot.innerHTML = `
                <tr>
                    <td colspan="2" class="text-right text-muted">TOTALES CONSOLIDADOS (USD):</td>
                    <td class="text-right font-mono">$${gJug.toFixed(2)}</td>
                    <td class="text-right font-mono">$${gPre.toFixed(2)}</td>
                    <td class="text-right font-mono" style="color:${gNeto>=0?'#34d399':'#f87171'};">${gNeto>=0?'+':''}$${gNeto.toFixed(2)}</td>
                    <td class="text-right font-mono" style="color:#60a5fa; font-size:1.15rem;">$${gCom.toFixed(2)}</td>
                </tr>
            `;

            // Actualizar Widgets
            container.querySelector('#wdg-dig-jugado').innerText = `$${gJug.toFixed(2)}`;
            container.querySelector('#wdg-dig-pagado').innerText = `$${gPre.toFixed(2)}`;
            container.querySelector('#wdg-dig-neto').innerText = `$${gNeto.toFixed(2)}`;
            container.querySelector('#wdg-dig-comision').innerText = `$${gCom.toFixed(2)}`;

            // Renderizar Gráfico
            if (chartInstance) chartInstance.destroy();
            
            const chartCategories = Array.from(allySalesMap.keys());
            const chartSales = chartCategories.map(k => parseFloat(allySalesMap.get(k).sales.toFixed(2)));
            const chartCommissions = chartCategories.map(k => parseFloat(allySalesMap.get(k).comm.toFixed(2)));

            const options = {
                chart: { type: 'bar', height: 300, toolbar: { show: false }, background: 'transparent', foreColor: '#94a3b8' },
                series: [{ name: 'Ventas Jugadores USD', data: chartSales }, { name: 'Comisión USD', data: chartCommissions }],
                xaxis: { categories: chartCategories },
                colors: ['#10b981', '#8b5cf6'],
                theme: { mode: 'dark' },
                plotOptions: { bar: { borderRadius: 4, horizontal: true, barHeight: '60%' } },
                dataLabels: { enabled: false },
                stroke: { show: true, width: 2, colors: ['transparent'] }
            };
            chartInstance = new ApexCharts(document.querySelector("#dig-chart"), options);
            chartInstance.render();

        } catch (e) { Notification(notificationContainer, e.message, 'error'); } 
        finally { btnGen.innerHTML = '<i class="fas fa-search"></i> Filtrar Data'; btnGen.disabled = false; }
    });

    await loadInitialData();
}

